export default {"src":"/_next/static/media/logo_fairprice_logooriginal.30fabb10.svg","height":40,"width":180};